<template>
  <section class="plan" :class="classes">
    <VText class="plan__title" variant="h2">
      <slot name="title">{{ title }}</slot>
    </VText>
    <div class="plan__price">
      <slot name="price">
        <span><sup>$</sup>{{ price }}</span> {{ priceDescription }}
      </slot>
    </div>
    <div class="plan__actions">
      <slot name="actions" />
      <div class="plan__actions__text">
        <slot name="below-actions" />
      </div>
    </div>
    <div class="plan__description">
      <slot name="description">
        <VText>{{ description }}</VText>
      </slot>
      <ul class="plan__features">
        <slot name="features">
          <li v-for="feature in features" :key="feature.title">
            <FancyIconCircle
              class="plan__feature-icon"
              :color="feature.checked === false ? 'error' : 'success'"
              size=".75rem"
            >
              <CheckIcon
                v-if="feature.checked === undefined || feature.checked === true"
                size="1.25rem"
              />
              <XIcon v-if="feature.checked === false" size="1rem" />
            </FancyIconCircle>
            <span>{{ feature.title }}</span>
          </li>
        </slot>
      </ul>
    </div>

    <Ribbon v-if="isHighlighted" color="secondary">Popular</Ribbon>
  </section>
</template>

<script>
import {
  VText,
  Ribbon,
  FancyIconCircle,
  CheckIcon,
  XIcon,
} from '@campsite-bio/component-lib';

export default {
  components: {
    VText,
    Ribbon,
    FancyIconCircle,
    CheckIcon,
    XIcon,
  },

  props: {
    isHighlighted: Boolean,

    title: {
      type: String,
      default: null,
    },

    description: {
      type: String,
      default: null,
    },

    price: {
      type: [String, Number],
      default: null,
    },

    priceDescription: {
      type: String,
      default: null,
    },

    features: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    classes() {
      return {
        'plan--highlight': this.isHighlighted,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.plan {
  background: #fff;
  padding: 1.875rem 1.5rem;
  border-top: 0.125rem solid transparent;
  overflow: hidden;
  position: relative;

  &--highlight {
    border: 1px solid var(--g-color-primary);
    transform: scale(1.02);
    z-index: 1;
  }
}

.plan__description {
  margin-top: 1.5rem;

  p {
    margin-bottom: 0;
    margin-top: 0.3125rem;
    min-height: 3.125rem;
  }
}

.plan__title {
  margin: 0;
}

.plan__price {
  margin: 0.5rem 0;
  font-size: 1.25rem;
}

.plan__actions {
  margin: 0.75rem 0;
  min-height: 5rem;

  &::v-deep .v-button {
    width: 100%;
  }

  &__text {
    font-size: 0.9rem;
    margin-top: 0.25rem;

    &::v-deep .v-inline-link {
      font-size: inherit;
    }
  }
}

.plan__features {
  font-size: 0.925rem;
  margin: 1.25rem 0;
  padding: 0;
  list-style: none;

  li {
    padding-left: 2.5rem;
    line-height: 1.4;
    margin-bottom: 0.75rem;
    position: relative;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.plan__feature-icon {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
</style>
